import axios from "axios";

export const GET_CATALOGO_COBRO_LIST    = "GET_CATALOGO_COBRO_LIST";
export const GET_CATALOGO_COBRO_DETAIL  = "GET_CATALOGO_COBRO_DETAIL";
export const PUT_CATALOGO_COBRO_EDIT    = "PUT_CATALOGO_COBRO_EDIT";
export const POST_CATALOGO_COBRO_CREATE = "POST_CATALOGO_COBRO_CREATE";
export const DELETE_CATALOGO_COBRO      = "DELETE_CATALOGO_COBRO";
export const ACTIVAR_CATALOGO_COBRO     = "ACTIVAR_CATALOGO_COBRO";

export const getCatalogoCobroList = () => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getUsersList");
        axios
            .get("/api/CatalogoCobro/ObtieneTodosLosCatalogoCobro")
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_CATALOGO_COBRO_LIST,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_CATALOGO_COBRO_LIST,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getCatalogoCobroDetail = (id) => {

    return (dispatch) => {
        axios
            .get(
                "/api/CatalogoCobro/ObtieneCatalogoCobroPorId?id=" +id
            )
            .then(function (response) {
                //console.log(response.data);

                dispatch({
                    type: GET_CATALOGO_COBRO_DETAIL,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: GET_CATALOGO_COBRO_DETAIL,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH
}; //END DETAIL

export const putCatalogoCobroUpdate = (data, id) => {

    return (dispatch) => {
        axios
            .put(
                "/api/CatalogoCobro/" + id,data
                )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: PUT_CATALOGO_COBRO_EDIT,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: PUT_CATALOGO_COBRO_EDIT,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

}; //END UPDATE

export const postCatalogoCobroCreate = (data) => {

    return (dispatch) => {
        axios
        .post(
            "/api/CatalogoCobro",data
        )
        .then(function (response) {
            //console.log(response);
        
            dispatch({
                type: POST_CATALOGO_COBRO_CREATE,
                payload: {
                    data: response.data,
                    errorMessage: false,
                },
            });
        })
        .catch(function (error) {
            dispatch({
                type: POST_CATALOGO_COBRO_CREATE,
                payload: {
                    data: false,
                    errorMessage: error.message,
                },
            });
        });
    };
  
};

export const deleteCatalogoCobro = (data, id) => {

    return (dispatch) => {

        //console.log("ACTION deleteCatalogoCobro");

        axios
            .put(
                "/api/CatalogoCobro/BorrarCatalogoCobro/" + id, data
            )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: DELETE_CATALOGO_COBRO,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: DELETE_CATALOGO_COBRO,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH
    
};


export const activarCatalogoCobro = (data, id) => {

    return (dispatch) => {

        

        axios
            .put(
                "/api/CatalogoCobro/ActivarCatalogoCobro/" + id, data
            )
            .then(function (response) {
                //console.log(response);

                dispatch({
                    type: ACTIVAR_CATALOGO_COBRO,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: ACTIVAR_CATALOGO_COBRO,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });

    }; //END DISPATCH

};